import { PAYMENTS_SERVICE_URI } from "env";
import { assertOk, proxyFetch } from "./utils";

export const PM_STATE = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  UNVERIFIED: "UNVERIFIED",
};

const paymentsProxy = proxyFetch(PAYMENTS_SERVICE_URI);

export const getPaymentMethods = async (ctx) => {
  const response = await paymentsProxy(ctx, "/v1/payment_methods", "GET");
  assertOk(response);
  return response.json();
};

export const getPaymentMethod = async (ctx, id) => {
  const response = await paymentsProxy(ctx, `/v1/payment_method/${id}`, "GET");
  assertOk(response);
  return response.json();
};

// returns 404 if payment_method is inactive.
// callers must handle no payload and interpret as such.
export const getPaymentMethodAnyState = async (ctx, id) => {
  const response = await paymentsProxy(ctx, `/v1/payment_method/${id}?state=all`, "GET");
  assertOk(response, [404]);
  return response.json();
};

export const startCreatePaypal = async (ctx, state) => {
  const response = await paymentsProxy(ctx, "/payment_method/paypal", "POST", { state });
  assertOk(response);
  return response.json();
};

export const finishCreatePaypal = async (ctx, paypalToken, geoIPState, geoIPCountry) => {
  const response = await paymentsProxy(ctx, `/paypal/success/${paypalToken}`, "POST", {
    geoip_state: geoIPState,
    geoip_country: geoIPCountry,
  });
  assertOk(response);
  return response.json();
};

export const getPaypalSession = async (ctx) => {
  const response = await paymentsProxy(ctx, "/paypal/session", "POST");
  assertOk(response);
  return response.json();
};

export const createACHPaymentMethod = async (ctx, values) => {
  const response = await paymentsProxy(ctx, "/payment_method/ach", "PUT", {
    holder_name: values.accountHolder,
    account_number: values.accountNumber,
    routing_number: values.routingNumber,
    account_type: values.accountType,
  });
  assertOk(response);
  return response.json();
};

export const startCreateCCAdyen = async (ctx) => {
  const response = await paymentsProxy(ctx, "/payment_method/adyen", "POST");
  assertOk(response);
  return response.json();
};

export const finishCreateCCAdyen = async (ctx, values) => {
  const payload = {
    ip_address: values.ipAddress,
    geoip_state: values.geoIPState,
    geoip_country: values.geoIPCountry,
    first: values.firstname,
    last: values.lastname,
    street_address_1: values.street,
    state_province: values.state,
    city: values.city,
    country: values.country,
    zip_postal_code: values.zip,

    encryptedCardNumber: values.encryptedCardNumber,
    encryptedExpiryMonth: values.encryptedExpiryMonth,
    encryptedExpiryYear: values.encryptedExpiryYear,
    encryptedSecurityCode: values.encryptedSecurityCode,
  };
  const response = await paymentsProxy(ctx, "/payment_method/adyen", "PUT", payload);
  assertOk(response);
  return response.json();
};

export const finishCreateCCRebilly = async (ctx, payload) => {
  const response = await paymentsProxy(ctx, "/payment_method/rebilly", "PUT", payload);
  assertOk(response);
  return response.json();
};

export const getPlaidLinkToken = async (ctx) => {
  const response = await paymentsProxy(ctx, "/v2/banking/plaid", "POST");
  const data = await response.json();
  assertOk(response);
  return Promise.resolve(data);
};

export const exchangePlaidPublicToken = async (ctx, payload) => {
  const response = await paymentsProxy(ctx, "/v2/banking/plaid", "PUT", payload);
  const data = await response.json();
  assertOk(response, [], data);
  return Promise.resolve(data);
};
